import { defineComponent, ref, computed, resolveComponent, openBlock, createBlock, withCtx, createElementVNode, mergeProps, renderSlot } from 'vue';
import { useScrollLock } from '@vueuse/core';
import { K } from '../OrAutocompleteV3-961163d0.js';
import { OrTeleportV3 as script$1 } from '../or-teleport-v3/index.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import './index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-4e69972f.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

const Overlay = [
// Position
'fixed inset-0',
// Layout
'layout-row justify-center',
// Theme
'theme-background-overlay', 'dark:theme-background-overlay-dark', 'theme-foreground-base', 'dark:theme-foreground-base'];

var script = defineComponent({
  name: 'OrOverlay',
  components: {
    OrTeleport: script$1
  },
  inheritAttrs: false,
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props, context) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-overlay-v3', ...Overlay]);
    // Effects
    // #region Elevation
    K(root);
    // #endregion
    // #region Scroll Lock
    useScrollLock(document.body, true);
    // #endregion
    // Handlers
    function onClick(event) {
    }
    return {
      root,
      rootStyles,
      onClick
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrTeleport = resolveComponent("OrTeleport");
  return openBlock(), createBlock(_component_OrTeleport, {
    disabled: !_ctx.fullscreen
  }, {
    default: withCtx(() => [createElementVNode("div", mergeProps(_ctx.$attrs, {
      ref: 'root',
      class: _ctx.rootStyles,
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
    }), [renderSlot(_ctx.$slots, "default")], 16 /* FULL_PROPS */)]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled"]);
}

script.render = render;
script.__file = "src/components/or-overlay-v3/OrOverlay.vue";

export { script as OrOverlayV3 };
